__turbopack_context__.v({
  "iconRoot": "IconWrapper-module-scss-module__vIT0jG__iconRoot",
});
